import React, { useState, useEffect, useContext, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, TextField, MenuItem, Table, TableHead, TableBody, TableRow, TableCell, IconButton, InputAdornment, Checkbox, makeStyles, useMediaQuery } from '@material-ui/core'
import { isMobile } from 'react-device-detect';
import { useSwipeable } from 'react-swipeable'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import SaveIcon from '@material-ui/icons/Save'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import { AuthContext } from '../../App.js'
import './index.css'
import Header from '../Header'
import ModalDeleteAlert from '../ModalDeleteAlert'
import ModalLogoutAlert from '../ModalLogoutAlert'
import Loading from '../LoadingComponent'
import Confirmation from '../ConfirmationComponent'
import COLORS from '../../colors'
import axios from 'axios'
import { getHostName } from '../../base.js'
import {ReactComponent as Arrow} from '../../assets/arrow.svg'
import {ReactComponent as Search} from '../../assets/search.svg'


const useStyles = makeStyles((theme) => ({
      input: {
            background: '#F2F2F2',
	      borderRadius: '2rem',
            margin: '1rem'
      },
      table: {
            width:'100%',       
      },
      tableRow:{
            '&:hover': {
                  zIndex: '1000',
                  backgroundColor: COLORS.gray,
            }
      },
      checkbox: {
            padding:'1rem',
            width:'1rem',
            margin: '0rem',
      },
      arrow:{
            padding:'1rem',
            margin:0,
            paddingTop: '1.4rem',
            cursor: 'pointer'
      },
      nameHead: {
            paddingTop:'0.6rem',
            paddingBottom:'0.6rem',
            padingRight: 0,
            paddingLeft:0,
            margin:0,
            color:'#5F6767',
            fontWeight: '500',
      },
      priceHead: {
            padding:0,
            
            margin:0,
            color:'#5F6767',
            fontWeight: '500',
      },
      nameBody: {
            padding:0,
            color: COLORS.blue,
            fontWeight: '700',
            maxWidth: '45vw',
            cursor: 'pointer'     
      },
      priceBody:{
            padding:0,
            color: COLORS.green,
            fontWeight: '700',
            cursor: 'pointer' 
      },    
      root: {
            color: '#2F2F5B',
            "&$checked": {
              color: '#2F2F5B'
            }
      },
      btnNew: {
            position: 'fixed',
	      display:'flex',
	      justifyContent: 'center',
            background: COLORS.blue,
            color:'#fff',
            fontSize: '1rem',
            fontWeight: '500',
            zIndex: '1',
            "&:hover": {
                  backgroundColor: COLORS.blue
            }
	},
      btnNewArticle: {
	      display:'flex',
	      
	      justifyContent: 'center',
            background: COLORS.blue,
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 'bold',
            "&:hover": {
                  backgroundColor: COLORS.blue
            }    
	},
      btnEditArticle: {
	      display:'flex',
	       
	      justifyContent: 'center',
            background: COLORS.blue,
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 'bold',
            "&:hover": {
                  backgroundColor: COLORS.blue
            }  
	},
      btnCancle: {
	      display:'flex',
	      
	      justifyContent: 'center',
            background: '#fff',
            border: '2px solid #2F2F5B',
            color: COLORS.blue,
            fontSize: '1rem',
            fontWeight: 'bold',
            marginTop: '0.6rem',
            marginBottom: '0.6rem',
            "&:hover": {
                  backgroundColor: 'fff'
            } 
	},
      inputForm:{
            display: 'flex',
            justifyContent: 'center',
            margin: '1rem',
      },
      inputNewcategory:{
            display: 'flex',
            justifyContent: 'right',
            marginLeft:'5rem',
            marginRight: '1rem'
      }
  }));

const AdminArticles = ({cid, editedArticle, token, articleList, articleCategory, unitCategory, taxCategory}) => {

      const matches = useMediaQuery('(min-width:600px)')
      const [ isOpen, setIsOpen ] = useState(false)
      const [ articles, setArticles ] = useState([])
	const [ searchString, setSearchString ] = useState('')
	const [ searchArr, setSearchArr ] = useState([])
      const [ isLoading, setIsLoading ] = useState(true)
      const [ isChecked, setIsChecked ] = useState(false)
      const [ checkedDict, setCheckedDict ] = useState({})
      const [ popup, setPopup ] = useState(false)

      const [ newCategory, setNewCategory ] = useState('')
      const [ addCategory, setAddCategory ] = useState(false)
     
      const classes = useStyles()
      
      const navigate = useNavigate()
      const params = useParams()
      const { editArticle, 
            resetEditedArticle, 
            setArticleList, 
            setPageNumber, 
            setPrevPage, 
            setArticleCategory, 
            signOut, 
            resetPN } = useContext(AuthContext)

      const [ name, setName ] = useState('');
      const [ unit, setUnit ] = useState('');
      const [ code, setCode ] = useState('');
      const [ category, setCategory ] = useState('');
      const [ price, setPrice ] = useState('')
      const [ tax, setTax ] = useState(taxCategory[0].id)
      const [ isDisabled, setIsDisabled ] = useState(true)
      const [ isConfirm, setIsConfirm ] = useState(false)
      const [ keypad, setKeypad ] = useState(false)
      const [ inputName, setInputName ] = useState(null)
      const [ inputUnit, setInputUnit ] = useState(null)
      const [ inputCode, setInputCode ] = useState(null)
      const [ inputCategory, setInputCategory ] = useState(null)
      const [ inputPrice, setInputPrice ] = useState(null)
      const [ inputTax, setInputTax ] = useState(null)
      const [ popupIsModalLogout, setPopupIsModalLogout ] = useState(false)
      const [ width, setWidth ] = useState(window.innerWidth);
	const [ height, setHeight ] = useState(window.innerHeight);

      useEffect(()=>{
            function hideKeypad(){
                  setWidth(window.innerWidth)
                  setHeight(window.innerHeight)	 	 
            }
            window.addEventListener('resize', hideKeypad, false)
            return () => window.removeEventListener('resize', hideKeypad, false)
      },[])

      // setup ref for your usage
	const myRef = useRef();
	const handlers = useSwipeable({ onSwipedLeft: () => handleSwipeLeft() })

      const handleSwipeLeft = () => {
            setPageNumber(null)
            navigate(`/kekspos/${params.tid}`)
      }

	const refPassthrough = (el) => {
			// call useSwipeable ref prop with el
			handlers.ref(el)
			// set myRef el so you can access it yourself
			myRef.current = el
	}

      useEffect(()=>{
            if(height>500&&inputName!==null){
                  inputName.blur()
            }
            if(height>500&&inputUnit!==null){
                  inputUnit.blur()
            }
            if(height>500&&inputCode!==null){
                  inputCode.blur()
            }
            if(height>500&&inputCategory!==null){
                  inputCategory.blur()
            }
            if(height>500&&inputPrice!==null){
                  inputPrice.blur()
            }
            if(height>500&&inputTax!==null){
                  inputTax.blur()
            }
      },[height])

      const handleInputScroll = () => {
            setKeypad(true)
            document.querySelector(".admin-article")
                  .scrollTo({ left: 0, top: document.querySelector(".admin-article")
                  .scrollHeight, behavior: "smooth" })
      }
      const handleName = (e) => {
            e.persist()
            if(e.target.value.length<50){
                  setName(e.target.value)
            }
      }
      const handleUnit = (e) => {
            e.persist()
            setUnit(e.target.value)
      }
      const handleCode = (e) => {
            e.persist()
            if(e.target.value.length<13){
                  setCode(e.target.value)
            }
      }
      const handleCategory = (e) => {
            e.persist()
            setCategory(e.target.value)
      }
      const handlePrice = (e) => {
            if(price<1000000){
                  if(e.key>=0 && e.key<=9){
                        setPrice((price*10+parseInt(e.key)*0.01).toFixed(2))
                  }else if(e.key==='Backspace'){
                        setPrice((Math.floor(price*10)/100).toFixed(2))
                  }
            }else if(e.key==='Backspace'){
                  var articelPrice = Math.floor((price*10)/100).toFixed(2)
                  if(articelPrice===0){
                        setPrice('')
                  }else{
                        setPrice(articelPrice)
                  }
            }
      }
      const handleTax = (e) => {
            e.persist()
            setTax(e.target.value)
      }
       
      useEffect(()=>{
            if(editedArticle===null){
                  if(name!==''&&unit!==''&code!==''&&category!==''&&price!==''&&tax!==''){
                                    setIsDisabled(false)
                  }else{
                                    setIsDisabled(true)
                  }
            }else if(editedArticle!==null){
                  if(name!==editedArticle.name||unit!==parseInt(editedArticle.unit)||
                        code!==editedArticle.code||category!==parseInt(editedArticle.description)
                              ||price!==editedArticle.price||tax!==editedArticle.pdv)
                  {
                        if(name!==''&&unit!==''&code!==''&&category!==''&&price!==''&&tax!==''){
                              setIsDisabled(false)
                        }else{
                              setIsDisabled(true)
                        }
                  }else{
                        setIsDisabled(true)
                  }
            }
      },[name, unit, code, category, price, tax])

      useEffect(() => {
            setPrevPage({prevPageNum:8})
            window.onpopstate = function(e)
            {
                  e.preventDefault()
                  window.setTimeout(function () {
                        resetPN()
                        navigate(`/kekspos/${params.tid}`)
                        //window.location = getHostName() + `/kekspos/?cid=${cid}`
                  }, 0)

                  window.onpopstate=null

                  //return "Data will be lost if you leave the page, are you sure?";
            }
            
      }, [])
      
      const onBackButtonEvent = (e) => {
            e.preventDefault()
            
            //signOut(cid)
            navigate(`/kekspos/${params.tid}`)	
            resetPN() 	 
      }     

      const getData = async () => {
            const config = {
                  headers:{
                    'X-Session-Token':token
                  }
                };

            return await axios.get(getHostName() + '/article?tid=' + params.tid, config).then(response => {
                                    return response.data
            }).catch(error => {
                                    signOut(cid)
                                    console.log("Error happend while requesting the data...")
            })
      }

      useEffect(() => {
            if(articleList.length===0){
                  setIsLoading(true)
                  getData().then(apiData => {
                        console.log(apiData)
                        if(apiData.resultCode===0){ 			
                              setArticles(apiData.result)
                              setArticleList(apiData.result) 
                              setTimeout(() => setIsLoading(false), 1000)
                        }else{
                              setTimeout(() => setIsLoading(false), 1000)
                              setPopupIsModalLogout(true)     
                        }                        
                  })
            }else{
                  setArticles(articleList)
                  setTimeout(() => setIsLoading(false), 1000)
            }
      },[])

      useEffect(() => {
            const loadCheckBox = () => {
                   var arr = {}
                  for (let num in articles) {
                         arr[articles[num].id]=false
                   }
                   setCheckedDict(arr)
            }       
            loadCheckBox()  
       },[articles])

      const newData = async (articleName, articleUnit, articleCode, articleCat, articlePrice, taxIsTheft) => {
            const config = {
                  headers:{
                    'X-Session-Token':token
                  }
                };
            return await axios.post(getHostName() + '/article', 
                  {     
                        tid: params.tid,
                        name: articleName, 
                        unit:articleUnit, 
                        price:parseFloat(articlePrice), 
                        description:articleCat, 
                        pdv:taxIsTheft, 
                        pos:1, 
                        code:articleCode, 
                        articleType:2
                  },config).then(response => {
                        return response.data 
                  }).catch(error => {
                        signOut(cid)
                        console.log("Error happend while requesting the data...")
                  })
      }

      // call API for creating new article
      const handleSubmitNewArticle = async (event) => {
            event.preventDefault()
            setIsLoading(true)
            newData(name, unit, code, category, price, tax).then(apiData => {
                              if(apiData.resultCode===0){
                                    setName('')
                                    setUnit('')
                                    setCode('')
                                    setCategory('')
                                    setPrice('')
                                    setTax(taxCategory[0].id)
                                    var articleList = [...articles, apiData.result]
                                    articleList.sort((a,b)=>(a.name>b.name?1:-1))
                                    setArticles(articleList)
                                    setArticleList(articleList)
                                    setIsDisabled(true)
                                    setIsLoading(false)
                                    setIsOpen(false)
                                    setIsConfirm(true)
                              }else{
                                    setTimeout(() => setIsLoading(false), 1000)
                                    setPopupIsModalLogout(true)
                              }
            })
      }

      const editData = async (articleName, articleUnit, articleCode, articleCat, articlePrice, taxIsTheft) => {
            const config = {
                  headers:{
                    'X-Session-Token':token
                  }
                };
            return await axios.put(getHostName() + '/article', 
                                    { 
                                          id:editedArticle.id, 
                                          tid:params.tid,
                                          name: articleName, 
                                          unit:articleUnit.toString(), 
                                          price:parseFloat(articlePrice), 
                                          description:articleCat.toString(), 
                                          pdv:taxIsTheft, 
                                          pos:1, 
                                          code:articleCode, 
                                          articleType:2
                                    },config).then(response => {
                                          return response.data 
                                    }).catch(error => {
                                          console.log("Error happend while requesting the data...")
                                          signOut(cid)
                                    })
      }

      // call API for editing article
      const handleSubmitEditArticle = async (event) => {
            event.preventDefault()
            setIsLoading(true)
            editData(name, unit, code, category, price, tax).then(apiData => {
                        if(apiData.resultCode===0){
                              setName('')
                              setUnit('')
                              setCode('')
                              setCategory('')
                              setPrice('')
                              setTax(taxCategory[0].id)   
                              var arr = articles.filter(item => item.id!==editedArticle.id)
                              var articleList = [...arr,apiData.result] 
                              articleList.sort((a,b)=>(a.name>b.name?1:-1))
                              setArticles(articleList)
                              setArticleList(articleList)
                              resetEditedArticle()
                              setIsDisabled(true)
                              setIsOpen(false)
                              setIsLoading(false)
                        }
                        else
                        {
                              setTimeout(() => setIsLoading(false), 1000)
                              setPopupIsModalLogout(true)
                        }           
            })                
      }

      const removeData = async (items) => {
            const config = {
                  headers:{
                    'X-Session-Token':token
                  }
                };
            return await axios.delete(getHostName() + '/article',{data:{ids:items,tid:params.tid},headers:{'X-Session-Token':token}}).then(response => {
                  console.log("response: ", response.data )
                  return response.data
            }).catch(error => {
                  signOut(cid)
                  console.log("Error happend while requesting the data...")
            })
      }

      const handleDeleteItems = () => {
            var checkedElements = {}
            var arr=articles
            var itemsToBeRemoved = []
            for(let id in checkedDict){
                  if(checkedDict[id]){
                        itemsToBeRemoved = [...itemsToBeRemoved, parseInt(id)]
                        arr=arr.filter(item => item.id!==parseInt(id))
                  }else{
                        checkedElements[id]=false
                  }        
            }
            setIsLoading(true) 
            removeData(itemsToBeRemoved).then(apiData => {
                  console.log(apiData)
                  if(apiData.resultCode===0){
                        setArticles(arr)
                        setArticleList(arr)  
                        setCheckedDict(checkedElements)
                        setIsLoading(false)
                        setIsChecked(false)
                        setPopup(false)
                  }
                  else
                  {
                        setPopup(false)
                        setTimeout(() => setIsLoading(false), 1000)
                        setPopupIsModalLogout(true)
                  }
            })       
      }

      const showDeleteButton = () => {
                  let sum=0
                  for(let ele in checkedDict){
                        if(checkedDict[ele]){
                              sum+=1
                              setIsChecked(true)
                              return
                        }         
                  }
                  if(sum===0 && isChecked){
                        setIsChecked(false)
                  }
      }

      const handleCheckboxChange = (event, id) => {
            var checkedEle=checkedDict
            checkedEle[id]=!checkedEle[id]
            setCheckedDict(checkedEle)
            showDeleteButton()     
      }

      const handleSearch = (event) => {
            event.persist()
            setSearchString(event.target.value)
      }

      useEffect(() => {
                  setSearchArr(articles.filter(item => item.name.toLowerCase().includes(searchString.toLowerCase())))	    
      }, [searchString, articles])

      // on category creation
      const insertCategory = async (categoryToBeInserted) => {
            const config = {
                  headers:{
                    'X-Session-Token':token,
                    //'cid':cid
                  }
                };
            return await axios.post(getHostName() + '/category',
            {description:categoryToBeInserted, cid:cid },config).then(response => {
                  return response.data 
            }).catch(error => {
                  signOut(cid)
                  console.log("Error happend while inserting the data...")
             })
      }

      const handleNewCategory = () => {
            var arr=[]
            for(let num in articleCategory){
                  arr.push(articleCategory[num].description)  
            }
            if(newCategory!=='' && !arr.includes(newCategory)){
                  setIsLoading(true)
                  insertCategory(newCategory).then(apiData => {
                              if(apiData.resultCode===0){
                                    setArticleCategory([...articleCategory, {'description':apiData.result.description, 'id':apiData.result.id}])
                                    setCategory(apiData.result.id)
                                    setNewCategory('')
                                    setAddCategory(false)
                                    setIsLoading(false)
                              }else{
                                    setTimeout(() => setIsLoading(false), 1000)
                                    setPopupIsModalLogout(true)
                              }
                  })      
            }             
      }

      const handleEditArticle = (item) => {
            setName(item.name)
            setUnit(parseInt(item.unit))
            setCode(item.code)
            setCategory(parseInt(item.description))
            setPrice(item.price)
            setTax(item.pdv)
            editArticle(item)
            setIsOpen(true)
            setIsChecked(false)
      }

      const handleClose = () => 
      {
            setName('')
            setUnit('')
            setCode('')
            setCategory('')
            setPrice('')
            setTax(taxCategory[0].id)
            if(editedArticle!==null){
                  resetEditedArticle()
            }
            setIsDisabled(true)
            setIsOpen(false)
      }

      const handleBackToAddNewArticle = () => 
      {
            setIsConfirm(false)
            setIsOpen(true)
      }

      useEffect(() => 
      {   
            const handleReload = async (e) => 
            {
                  e.preventDefault()
                  signOut(cid)
                  setTimeout(() => window.location.assign(`/kekspos`, 0));
                  window.removeEventListener('beforeunload', handleReload) 
                  return false
            }

            window.addEventListener("beforeunload", handleReload)
         
            return () => 
            {    
                   window.removeEventListener('beforeunload', handleReload) 
            }
  
  	}, [])

      const handleLogout = () => {
            setPopupIsModalLogout(false)
            setIsLoading(true)
            setTimeout(() => setIsLoading(false), 1000)
            resetPN()
            setTimeout(() => window.location.assign(`/kekspos`, 0))
      }

  if(!isLoading&&!isConfirm){
  return (
    <div className="admin-article">
      <ModalDeleteAlert popup={popup} pageNumber={8} onClose={()=>setPopup(false)} onDelete={()=>handleDeleteItems()}/>
      <ModalLogoutAlert popup={popupIsModalLogout} onClose={()=>handleLogout()} />
      {editedArticle===null?
            (<div className={isOpen?"modal-open":"modal-close"} style={{height:height>500?'100vh':'85vh'}}>
                        <Header pageNumber={11} onClose={()=>handleClose()}/>
                        <form noValidate autoComplete="off" onSubmit={ (event) => handleSubmitNewArticle(event)}>
                              <TextField label="Naziv proizvoda"
                                    variant="outlined"
                                    type="text"
                                    name="name"
                                    onFocus={()=>setKeypad(true)}
                                    onBlur={()=>setKeypad(false)}
                                    inputRef={(input)=>{if(input!=null){ setInputName(input)} }}
                                    className={classes.inputForm}
                                    value={name}
						onChange={(e)=>handleName(e)}
                              />
                              <TextField label="Mjerna jedinica"
                                    variant="outlined"
                                    type="text"
                                    name="unit"
                                    className={classes.inputForm}
                                    select
                                    onFocus={()=>setKeypad(true)}
                                    onBlur={()=>setKeypad(false)}
                                    value={unit}
						onChange={(e)=>handleUnit(e)}
                              >
                              {unitCategory.map((item, id) => <MenuItem key={id} value={item.id}>{item.description}</MenuItem>)}
                              </TextField>
                              <TextField label="Šifra proizvoda"
                                    variant="outlined"
                                    type="text"
                                    name="code"
                                    inputRef={(input)=>{if(input!=null){ setInputCode(input)} }}
                                    className={classes.inputForm}
                                    onFocus={()=>setKeypad(true)}
                                    onBlur={()=>setKeypad(false)}
                                    value={code}
						onChange={(e)=>handleCode(e)}
                              />
                              <TextField label="Odaberi ili dodaj novu kategoriju"
                                    variant="outlined"
                                    type="text"
                                    name="number"
                                    className={classes.inputForm}
                                    onFocus={()=>setKeypad(true)}
                                    onBlur={()=>setKeypad(false)}
                                    InputProps = {{
                                          className: classes.inputChategory,
                                          startAdornment:(
                                                !addCategory?(<InputAdornment position="start">
                                                              <IconButton  onClick={()=>setAddCategory(true)}>
                                                                    <AddIcon />
                                                              </IconButton>
                                                          </InputAdornment>):(
                                                          <InputAdornment position="start">
                                                              <IconButton onClick={()=>setAddCategory(false)}>
                                                                    <RemoveIcon />
                                                              </IconButton>
                                                          </InputAdornment>)
                                          )
                                    }}
                                    select
                                    value={category}
						onChange={(e)=>handleCategory(e)}
                              >
                              {articleCategory.map((item, id) => <MenuItem key={id} value={item.id}>{item.description}</MenuItem>)}  
                              </TextField>
                              {addCategory&&<TextField label="Upiši novu kategoriju"
                                                      variant="outlined"
                                                      className = {classes.inputNewcategory}
                                                      value={newCategory}
                                                      onFocus={()=>setKeypad(true)}
                                                      onBlur={()=>setKeypad(false)}
                                                      onChange={(event) => setNewCategory(event.target.value)}
                                                      InputProps = {{
                                                            className: classes.inputChategory,
                                                             endAdornment: (
                                                                  <InputAdornment position="start">
                                                                        <IconButton onClick={()=>handleNewCategory()}>
                                                                              <SaveIcon />
                                                                        </IconButton>
                                                                  </InputAdornment>
                                                            )
                                                      }}
                                        />}
                              <TextField label="Cijena s PDV-om"
                                    variant="outlined"
                                    type="number"
                                    name="price"
                                    inputProps={{style: { fontSize: '1.3rem',
									paddingRight:'0.5rem' }
                                                }}
                                    inputRef={(input)=>{if(input!=null){ setInputPrice(input)} }}
                                    className={classes.inputForm}
                                    InputProps = {{
                                          endAdornment: (
                                                <InputAdornment position="start">
                                                      <span style={{color:'#5F6767',
                                                                        fontSize:'1.3rem',
                                                                        }}>&#8364;</span>
                                                </InputAdornment>
                                           )
                                    }}
                                    onFocus={()=>handleInputScroll()}
                                    onBlur={()=>setKeypad(false)}
                                    value={price}
						onKeyDown={(e)=>handlePrice(e)}
                              />
                              <TextField label="Postotak PDV-a"
                                    variant="outlined"
                                    type="text"
                                    name="tax"
                                    className={classes.inputForm}
                                    select
                                    onFocus={()=>setKeypad(true)}
                                    onBlur={()=>setKeypad(false)}
                                    value={tax}
						onChange = {e=>handleTax(e)}
                              >
                              {taxCategory.map((item, id) => <MenuItem key={id} value={item.id}>{item.rate}%</MenuItem>)}
                              </TextField>
                              {(!keypad||!isMobile)?
                                    <div className="article-btn">         
                                          <Button size="large"
                                            variant="contained"
                                            type="submit"
                                            className={classes.btnNewArticle}
                                            style={{width:!isMobile?'25rem':'90%'}}
                                            disabled={isDisabled}
                                          >SPREMI</Button>
                                    </div>:null
                              }
                        </form>
                        {(!keypad||!isMobile)?
                              <div className="article-btn">
                                    <Button size="large"
                                          variant="contained"
                                          className={classes.btnCancle}
                                          style={{width:!isMobile?'25rem':'90%'}}
                                          onClick={()=>handleClose()}
                                    >ODUSTANI</Button>
                        </div>:null}       
            </div>
            ):(
            <div className={isOpen?"modal-open":"modal-close"} style={{height:height>500?'100vh':'85vh'}}>
                        <Header pageNumber={12} onClose={()=>handleClose()}/>
                        <form noValidate autoComplete="off" onSubmit={ (event) => handleSubmitEditArticle(event)}>
                              <TextField label="Naziv proizvoda"
                                   variant="outlined"
                                   type="text"
                                   name="name"
                                   inputRef={(input)=>{if(input!=null){ setInputName(input)} }}
                                   className={classes.inputForm}
                                   onFocus={()=>setKeypad(true)}
                                   onBlur={()=>setKeypad(false)}
                                   value={name}
					     onChange = {(e)=>handleName(e)}
                              />
                              <TextField label="Mjerna jedinica"
                                   variant="outlined"
                                   type="number"
                                   name="unit"
                                   className={classes.inputForm}
                                   select
                                   onFocus={()=>setKeypad(true)}
                                   onBlur={()=>setKeypad(false)}
                                   value={unit}
					     onChange = {(e)=>handleUnit(e)}
                              >
                              {unitCategory.map((item, id) => <MenuItem key={id} value={item.id}>{item.description}</MenuItem>)}
                              </TextField>
                              <TextField label="Šifra proizvoda"
                                   variant="outlined"
                                   type="text"
                                   name="code"
                                   value={code}
                                   inputRef={(input)=>{if(input!=null){ setInputCode(input)} }}
                                   className={classes.inputForm}
                                   onFocus={()=>setKeypad(true)}
                                   onBlur={()=>setKeypad(false)}
					     onChange = {(e)=>handleCode(e)}
                              />
                              <TextField label="Odaberi ili dodaj novu kategoriju"
                                   variant="outlined"
                                   type="number"
                                   name="category"
                                   className={classes.inputForm}
                                   InputProps = {{
                                    className: classes.inputChategory,
                                     startAdornment:(
                                          !addCategory?(<InputAdornment position="start">
                                                            <IconButton  onClick={()=>setAddCategory(true)}>
                                                                  <AddIcon />
                                                            </IconButton>
                                                        </InputAdornment>):(
                                                        <InputAdornment position="start">
                                                            <IconButton onClick={()=>setAddCategory(false)}>
                                                                  <RemoveIcon />
                                                            </IconButton>
                                                        </InputAdornment>)
                                     )
                                   }}
                                   select
                                   value={category}
                                   onFocus={()=>setKeypad(true)}
                                   onBlur={()=>setKeypad(false)}
					     onChange = {(e)=>handleCategory(e)}
                              >
                              {articleCategory.map((item, id) => <MenuItem key={id} value={item.id}>{item.description}</MenuItem>)}   
                              </TextField>
                              {addCategory&&<TextField label="Upiši novu kategoriju"
                                                      variant="outlined"
                                                      className = {classes.inputNewcategory}
                                                      onFocus={()=>setKeypad(true)}
                                                      onBlur={()=>setKeypad(false)}
                                                      value={newCategory}
                                                      onChange={(event) => setNewCategory(event.target.value)}
                                                      InputProps = {{   className: classes.inputChategory,
                                                                        endAdornment: (
                                                                              <InputAdornment position="start">
                                                                                    <IconButton onClick={() => handleNewCategory()}>
                                                                                          <SaveIcon />
                                                                                    </IconButton>
                                                                              </InputAdornment>
                                                                                    )
                                                                  }}
                                          />}
                              <TextField label="Cijena s PDV-om"
                                    variant="outlined"
                                    type="number"
                                    name="price"
                                    inputProps={{style: { fontSize: '1.3rem',
									paddingRight:'0.5rem' }
                                    }}
                                    inputRef={(input)=>{if(input!=null){ setInputPrice(input)} }}
                                    className={classes.inputForm}
                                    InputProps = {{
                                          endAdornment: (
                                                <InputAdornment position="start">
                                                      <span style={{color:'#5F6767',
                                                                  fontSize:'1.3rem',
                                                                  }}>&#8364;</span>
                                                </InputAdornment>
                                          )    
                                    }}
                                   onFocus={()=>setKeypad(true)}
                                   onBlur={()=>setKeypad(false)}
                                   value={price}
					     onKeyDown = {(e)=>handlePrice(e)}
                              />
                              <TextField  label="Postotak PDV-a"
                                          variant="outlined"
                                          type="text"
                                          name="tax"
                                          className={classes.inputForm}
                                          onFocus={()=>setKeypad(true)}
                                          onBlur={()=>setKeypad(false)}
                                          select
                                          value={tax}
					            onChange = {(e)=>handleTax(e)}
                              >
                              {taxCategory.map((item, id) => <MenuItem key={id} value={item.id}>{item.rate}%</MenuItem>)}
                              </TextField>
                              {(!keypad||!isMobile)?
                                    <div className="article-btn">
                                          <Button size="large"
                                                variant="contained"
                                                type="submit"
                                                className={classes.btnEditArticle}
                                                style={{width:!isMobile?'25rem':'90%'}}
                                                disabled={isDisabled}
                                          >UREDI DETALJE</Button> 
                                    </div>:null
                              }
                        </form>
                        {(!keypad||!isMobile)?<div className="article-btn">
                              <Button size="large"
                                    variant="contained"
                                    className={classes.btnCancle}
                                    style={{width:!isMobile?'25rem':'90%'}}
                                    onClick={()=>handleClose()}
                              >ODUSTANI</Button>
                        </div>:null}
            </div>
            )}
            <div className="admin-articles" style={{zIndex:isOpen?'0':'1'}} {...handlers} ref={refPassthrough}>
		      <Header pageNumber={8}/>
                  <div className="admin-articles-main">
                        <div className="input-search">
                              <TextField  variant="outlined"
                                          onFocus={()=>setKeypad(true)}
                                          onBlur={()=>setKeypad(false)}
                                          style={{width:!isMobile?'35rem':'100%'}}
					            InputProps = {{   className: classes.input,
						                        startAdornment: (
							                        <InputAdornment position="start">
							                              <IconButton>
								                              <Search />
							                              </IconButton>
							                        </InputAdornment>
						                        )
						      }}
						      value={searchString}
						      onChange = { (event) => handleSearch(event) }	  
			    	      />
                        </div>
                        <div className="admin-articles-body">
                              <div className="admin-articles-table" style={{height:isMobile?'63vh':'70vh'}}>
                              <Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                                    <TableHead>
                                          <TableRow style={{zIndex:isOpen?'-1':'1'}}>
                                                <TableCell style={{padding:0, margin:0, width:!isMobile?'10%':'3%'}} 
                                                            component="td" 
                                                            scope="row"
                                                            align="right"
                                                />
                                                <TableCell  className={classes.nameHead}
                                                            style={{width:!isMobile?'50%':'60%'}}
                                                            component="td" 
                                                            scope="row"
                                                >Proizvod</TableCell>
                                                <TableCell className={classes.priceHead}
                                                            style={{ width:!isMobile?'20%':'30%'}} 
                                                            component="td" 
                                                            scope="row" 
                                                            align="right"
                                                >Cijena</TableCell>
                                                <TableCell style={{padding:0, margin:0, 
                                                            width:!isMobile?'10%':'3%'}}
                                                            component="td" 
                                                            scope="row" 
                                                            align="left"
                                                />
                                          </TableRow>
                                    </TableHead>
                                    {articles.length!==0?
                                    <TableBody>
                                          {searchArr.length===0?(
                                                articles.map((item, id)=>
                                                      <TableRow key={id} className={classes.tableRow}>
                                                            <TableCell className={classes.checkbox} 
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="right"
                                                            >
                                                                  <Checkbox key={item.id} 
                                                                        value={checkedDict[item.id]}
                                                                        className={classes.checkbox}
                                                                        style={{padding:0,margin:0}}
                                                                        icon={<CircleUnchecked />}
                                                                        checkedIcon={<CircleCheckedFilled className={classes.root}/>}
                                                                        onChange={event => handleCheckboxChange(event, item.id)}
                                                                  />
                                                            </TableCell>
                                                            <TableCell className={classes.nameBody} 
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="left"
                                                                        onClick={()=>handleEditArticle(item)}
                                                            ><div style={{wordWrap:'break-word'}}>{item.name}</div>
                                                            </TableCell>
                                                            <TableCell className={classes.priceBody}
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="right"
                                                                        onClick={()=>handleEditArticle(item)}
                                                            >{item.price} EUR</TableCell>
                                                            <TableCell className={classes.arrow} 
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="left"
                                                                        onClick={()=>handleEditArticle(item)}
                                                            >
                                                                  <Arrow/>
                                                            </TableCell>
                                                      </TableRow>) 
                                                ):(
                                                searchArr.map((item, id) =>
                                                      <TableRow key={id} className={classes.tableRow}>
                                                            <TableCell className={classes.checkbox} 
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="right"
                                                            >
                                                                  <Checkbox key={item.id} 
                                                                        value={checkedDict[item.id]}
                                                                        style={{padding:0,margin:0,cursor:'pointer'}}
                                                                        icon={<CircleUnchecked />}
                                                                        checkedIcon={<CircleCheckedFilled className={classes.root}/>}
                                                                        onChange={event=>handleCheckboxChange(event, item.id)}
                                                                  />
                                                            </TableCell>
                                                            <TableCell className={classes.nameBody}
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="left"
                                                                        onClick={()=>handleEditArticle(item)}
                                                            ><div style={{wordWrap:'break-word'}}>{item.name}</div>
                                                            </TableCell>
                                                            <TableCell className={classes.priceBody} 
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="right"
                                                                        onClick={()=>handleEditArticle(item)}
                                                            >{item.price} EUR</TableCell>
                                                            <TableCell className={classes.arrow} 
                                                                        component="td" 
                                                                        scope="row" 
                                                                        align="left"
                                                                        onClick={()=>handleEditArticle(item)}
                                                            >
                                                                  <Arrow/>
                                                            </TableCell>
                                                      </TableRow>)
                                                )} 
                                    </TableBody>:
                                    null}    
                              </Table> 
                              </div>
                              {!keypad||!isMobile?<div className="article-btn">
                                    {!isChecked?<Button size="large"
                                                      variant="contained"
                                                      className={classes.btnNew}
                                                      style={{top:!matches?'85vh':'90vh', width:!isMobile?'25rem':'90%'}}
                                                      onClick={() => setIsOpen(true)}
                                                >DODAJ NOVI PROIZVOD</Button>:
                                                <Button size="large"
                                                      variant="contained"
                                                      className={classes.btnNew}
                                                      style={{top:!matches?'85vh':'90vh', width:!isMobile?'25rem':'90%'}}
                                                      onClick={()=>setPopup(true)}
                                                >OBRIŠI OZNAČENE PROIZVODE</Button>}
                                                </div>:null}               
 		            </div>
                  </div>
            </div>   
    </div>
  )
  }else if(isLoading&&!isConfirm){
      return(
          <Loading />
          )
  }else if(!isLoading&&isConfirm){
      return(
          <Confirmation cid={cid}
                        processed={true}
                        pageNumber={8} 
                        onBackToArticleList={() => setIsConfirm(false)} 
                        onBackToAddNewArticle={() => handleBackToAddNewArticle()}/>
          )
  }
}

export default AdminArticles